// Rahmen: getönter Hintergrund der Zukunftshälfte, Trennlinie bei "heute" und
// die beiden Bereichsbeschriftungen. Der Stilwechsel an dieser Linie ist das
// wichtigste Signal im Chart — links gemessen, rechts erwartet.

import { PALETTE } from "../../palette";
import type { Model, Svg } from "../model";
import type { Strings } from "../../strings";

export function drawFrame(svg: Svg, model: Model, s: Strings): void {
    const { split, fwdW, plotTop, axisY, isNarrow } = model.layout;

    svg
        .append("rect")
        .attr("x", split)
        .attr("y", plotTop)
        .attr("width", fwdW)
        .attr("height", axisY - plotTop)
        .attr("fill", PALETTE.forwardWash);

    svg
        .append("line")
        .attr("x1", split)
        .attr("x2", split)
        .attr("y1", plotTop - 12)
        .attr("y2", axisY)
        .attr("stroke", PALETTE.ink)
        .attr("stroke-opacity", 0.55)
        .attr("stroke-width", 1);

    svg
        .append("text")
        .attr("x", split + 6)
        .attr("y", plotTop - 4)
        .attr("font-size", 10)
        .attr("fill", PALETTE.inkMuted)
        .text(s.today);

    if (!isNarrow) {
        svg
            .append("text")
            .attr("x", split - 6)
            .attr("y", plotTop - 4)
            .attr("text-anchor", "end")
            .attr("font-size", 10)
            .attr("fill", PALETTE.inkFaint)
            .text(s.history);
    }
}
